export class Voucher{
    voucher_id:any;
    user_id: any;
    debit_account: any;
    voucher_payee: any;
    voucher_towards: any;
    amount: number;
    voucher_date: any;
    voucher_reference: string;
}


// WEBPACK FOOTER //
// ./src/models/voucher.ts